<script>
  import { domainName, record, newRecordCreated } from '../stores.js';
  import SPFSearch from './spfSearch.svelte';
  import SPFResult from './spfResult.svelte';
  import Tools from '../Tools.svelte';
</script>

<svelte:head>
  <script src="//info.agari.com/js/forms2/js/forms2.min.js"></script>
</svelte:head>

{#if $domainName == '' }
  <SPFSearch />
  <Tools skip={'spf'} />
{:else}
  <SPFResult />
{/if}

<style>

</style>
